import React from 'react'

const Welcome = () => {
    console.count('welcome');
    return (
        <h2 className='welcome-msg'>
            Welcome to PhotoWeather!
        </h2>
    )
}

export default Welcome
